/**
 * @generated SignedSource<<347ae870bbdf73fe33fc7bea23ba372f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TrackOfTheMonthFragment$data = {
  readonly eventCompetitionPinned: {
    readonly competition: {
      readonly " $fragmentSpreads": FragmentRefs<"CompetitionCardFragment">;
    };
    readonly event: {
      readonly slug: string;
    };
  } | null | undefined;
  readonly " $fragmentType": "TrackOfTheMonthFragment";
};
export type TrackOfTheMonthFragment$key = {
  readonly " $data"?: TrackOfTheMonthFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TrackOfTheMonthFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TrackOfTheMonthFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventCompetition",
      "kind": "LinkedField",
      "name": "eventCompetitionPinned",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "event",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Competition",
          "kind": "LinkedField",
          "name": "competition",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CompetitionCardFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "db676060c4e847f1b716531e630059df";

export default node;
